import { styled } from '@attentive-platform/stem-ui';

export const TatStyles = {
  PresetCard: styled('div')(() => ({
    background: '#FFFFFF',
    border: '1px solid #E3E8FC',
    borderRadius: '12px',
    padding: '16px 18px',
    display: 'flex',
    flexDirection: 'column',
    gap: '14px',
    marginBottom: '4px'
  })),
  PresetHead: styled('div')(() => ({
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: '16px',
    flexWrap: 'wrap'
  })),
  PresetHeadCopy: styled('div')(() => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    minWidth: 0,
    flex: 1
  })),
  PresetTitle: styled('span')(() => ({
    fontSize: '15px',
    fontWeight: 600,
    color: '#1A1A1A'
  })),
  PresetSub: styled('span')(() => ({
    fontSize: '13px',
    color: '#666666',
    lineHeight: 1.45
  })),
  PresetJump: styled('button')(() => ({
    color: '#4361EE',
    fontWeight: 500,
    cursor: 'pointer',
    background: 'none',
    border: 0,
    padding: 0,
    font: 'inherit'
  })),
  PresetStatus: styled('span')(() => ({
    fontSize: '12.5px',
    color: '#4361EE',
    fontWeight: 500,
    flex: 'none',
    maxWidth: '280px',
    textAlign: 'right'
  })),
  PresetGrid: styled('div')(() => ({
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
    gap: '10px'
  })),
  PresetTile: styled('button', {
    shouldForwardProp: p => p !== '$matched' && p !== '$custom' && p !== '$suggested'
  })(({ $matched, $custom, $suggested }) => ({
    textAlign: 'left',
    border: `1px solid ${
      $matched ? '#4361EE' : $suggested ? '#A8B4F0' : $custom ? '#E8CF8A' : '#EBEBEB'
    }`,
    background: $matched ? '#F6F7FE' : $suggested ? '#FAFBFF' : '#FFFFFF',
    borderRadius: '10px',
    padding: '12px 14px',
    cursor: 'pointer',
    font: 'inherit',
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
    '&:disabled': { cursor: 'default', opacity: 0.85 }
  })),
  PresetTileTop: styled('div')(() => ({
    display: 'flex',
    justifyContent: 'space-between',
    gap: '8px'
  })),
  PresetN: styled('span')(() => ({
    fontSize: '11px',
    fontWeight: 600,
    letterSpacing: '.04em',
    textTransform: 'uppercase',
    color: '#808080'
  })),
  PresetState: styled('span', {
    shouldForwardProp: p => p !== '$matched' && p !== '$custom' && p !== '$suggested'
  })(({ $matched, $custom, $suggested }) => ({
    fontSize: '11.5px',
    fontWeight: 600,
    color: $matched ? '#112FBB' : $suggested ? '#4361EE' : $custom ? '#8A6A00' : '#4361EE',
    whiteSpace: 'nowrap'
  })),
  PresetName: styled('span')(() => ({
    fontSize: '14px',
    fontWeight: 600,
    color: '#1A1A1A',
    lineHeight: 1.35
  })),
  PresetDesc: styled('span')(() => ({
    fontSize: '12.5px',
    color: '#666666',
    lineHeight: 1.45
  })),
  PresetMeta: styled('div')(() => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
    marginTop: '4px',
    fontSize: '12px',
    color: '#808080'
  })),
  PresetDays: styled('span', { shouldForwardProp: p => p !== '$matched' })(({ $matched }) => ({
    color: $matched ? '#112FBB' : '#4D4D4D',
    fontWeight: 500
  })),

  TatCard: styled('div')(() => ({
    background: '#FFFFFF',
    border: '1px solid #EBEBEB',
    borderRadius: '12px',
    padding: '18px 20px',
    display: 'flex',
    flexDirection: 'column',
    gap: '14px',
    marginTop: '8px'
  })),
  TatIntro: styled('p')(() => ({
    margin: 0,
    fontSize: '14px',
    lineHeight: 1.5,
    color: '#666666',
    maxWidth: '70ch'
  })),
  TypicalAsk: styled('div')(() => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    padding: '12px 14px',
    background: '#F6F7FE',
    border: '1px solid #D0D8FB',
    borderRadius: '10px'
  })),
  TypicalAskLabel: styled('span')(() => ({
    fontSize: '14px',
    fontWeight: 600,
    color: '#1A1A1A'
  })),
  TypicalAskHint: styled('span')(() => ({
    fontSize: '12.5px',
    color: '#666666'
  })),
  ChipRow: styled('div')(() => ({
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px'
  })),
  RangeChip: styled('button', { shouldForwardProp: p => p !== '$on' })(({ $on }) => ({
    border: `1px solid ${$on ? '#4361EE' : '#E0E0E0'}`,
    background: $on ? '#EEF1FE' : '#FFFFFF',
    color: $on ? '#112FBB' : '#4D4D4D',
    borderRadius: '8px',
    padding: '7px 12px',
    font: 'inherit',
    fontSize: '13px',
    fontWeight: 500,
    cursor: 'pointer'
  })),
  TatHeadRow: styled('div')(() => ({
    display: 'flex',
    justifyContent: 'space-between',
    gap: '16px',
    alignItems: 'flex-start',
    flexWrap: 'wrap'
  })),
  TatHeadLeft: styled('div')(() => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '4px'
  })),
  TatCardName: styled('span')(() => ({
    fontSize: '17px',
    fontWeight: 600,
    color: '#1A1A1A'
  })),
  TatTier: styled('span')(() => ({
    fontSize: '12.5px',
    color: '#808080'
  })),
  TatHeadRight: styled('div')(() => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    gap: '2px'
  })),
  TatHeadline: styled('span', { shouldForwardProp: p => p !== '$ready' })(({ $ready }) => ({
    fontSize: $ready ? '22px' : '16px',
    fontWeight: 600,
    letterSpacing: '-0.01em',
    color: $ready ? '#112FBB' : '#808080',
    lineHeight: 1.1
  })),
  TatHeadSub: styled('span')(() => ({
    fontSize: '12.5px',
    color: '#808080'
  })),
  TatPresetLine: styled('span')(() => ({
    fontSize: '13.5px',
    color: '#4D4D4D'
  })),
  TatWhy: styled('span')(() => ({
    fontSize: '13px',
    color: '#4D4D4D'
  })),
  TatWhyLabel: styled('span')(() => ({
    color: '#808080'
  })),
  RangeGrid: styled('div')(() => ({
    display: 'grid',
    gap: '6px'
  })),
  RangeCell: styled('button', { shouldForwardProp: p => p !== '$hi' })(({ $hi }) => ({
    border: `1px solid ${$hi ? '#4361EE' : '#EBEBEB'}`,
    background: $hi ? '#F6F7FE' : '#FFFFFF',
    borderRadius: '8px',
    padding: '10px 8px',
    cursor: 'pointer',
    font: 'inherit',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '2px',
    '&:disabled': { cursor: 'default' }
  })),
  RangeCellHead: styled('span', { shouldForwardProp: p => p !== '$hi' })(({ $hi }) => ({
    fontSize: '11.5px',
    fontWeight: 500,
    color: $hi ? '#112FBB' : '#808080'
  })),
  RangeCellVal: styled('span', { shouldForwardProp: p => p !== '$hi' })(({ $hi }) => ({
    fontSize: $hi ? '24px' : '18px',
    fontWeight: 600,
    color: $hi ? '#112FBB' : '#212121',
    lineHeight: 1.1
  })),
  RangeCellUnit: styled('span', { shouldForwardProp: p => p !== '$hi' })(({ $hi }) => ({
    fontSize: '11px',
    color: $hi ? '#4361EE' : '#9E9E9E'
  })),
  TatNote: styled('span')(() => ({
    fontSize: '12.5px',
    color: '#666666',
    lineHeight: 1.5
  })),
  OthersBlock: styled('div')(() => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    paddingTop: '4px',
    borderTop: '1px solid #F0F0F0'
  })),
  OthersHead: styled('div')(() => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '12px'
  })),
  OthersTitle: styled('span')(() => ({
    fontSize: '13.5px',
    fontWeight: 600,
    color: '#1A1A1A'
  })),
  CompareBtn: styled('button')(() => ({
    fontSize: '12.5px',
    fontWeight: 500,
    color: '#163CE9',
    background: 'none',
    border: 0,
    padding: 0,
    cursor: 'pointer',
    fontFamily: 'inherit'
  })),
  OtherRow: styled('div')(() => ({
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '10px 12px',
    border: '1px solid #EBEBEB',
    borderRadius: '10px',
    background: '#FAFAFA'
  })),
  OtherMain: styled('div')(() => ({
    flex: 1,
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: '2px'
  })),
  OtherName: styled('span')(() => ({
    fontSize: '13.5px',
    fontWeight: 600,
    color: '#1A1A1A'
  })),
  OtherChange: styled('span')(() => ({
    fontSize: '12.5px',
    color: '#666666'
  })),
  OtherDelta: styled('div', { shouldForwardProp: p => p !== '$tone' })(({ $tone }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    gap: '1px',
    fontSize: '12px',
    color: '#808080',
    '& strong': {
      fontSize: '13.5px',
      fontWeight: 600,
      color: $tone === 'warn' ? '#995C00' : $tone === 'good' ? '#1B6E43' : '#4D4D4D'
    }
  })),
  SwitchBtn: styled('button')(() => ({
    border: '1px solid #B9C5F8',
    background: '#FFFFFF',
    color: '#163CE9',
    borderRadius: '8px',
    padding: '6px 12px',
    font: 'inherit',
    fontSize: '13px',
    fontWeight: 500,
    cursor: 'pointer',
    flex: 'none'
  })),
  CompareTable: styled('div')(() => ({
    border: '1px solid #EBEBEB',
    borderRadius: '10px',
    overflow: 'hidden'
  })),
  CompareHead: styled('div')(() => ({
    display: 'grid',
    gap: 0,
    padding: '9px 14px',
    background: '#FAFAFA',
    borderBottom: '1px solid #EBEBEB',
    fontSize: '11.5px',
    fontWeight: 600,
    color: '#808080',
    alignItems: 'center'
  })),
  CompareColHead: styled('span', { shouldForwardProp: p => p !== '$hi' })(({ $hi }) => ({
    textAlign: 'center',
    whiteSpace: 'nowrap',
    color: $hi ? '#112FBB' : '#808080',
    fontWeight: $hi ? 700 : 600
  })),
  CompareRow: styled('div', { shouldForwardProp: p => p !== '$on' })(({ $on }) => ({
    display: 'grid',
    gap: 0,
    padding: '10px 14px',
    borderBottom: '1px solid #F5F5F5',
    background: $on ? '#F6F7FE' : '#FFFFFF',
    alignItems: 'center',
    '&:last-child': { borderBottom: 'none' }
  })),
  CompareName: styled('span')(() => ({
    fontSize: '13px',
    fontWeight: 500,
    color: '#1A1A1A'
  })),
  CompareCell: styled('span', { shouldForwardProp: p => p !== '$hi' })(({ $hi }) => ({
    textAlign: 'center',
    fontSize: '13px',
    fontWeight: $hi ? 600 : 400,
    color: $hi ? '#112FBB' : '#4D4D4D'
  })),

  ReviewCard: styled('div')(() => ({
    background: '#F6F7FE',
    border: '1px solid #D0D8FB',
    borderRadius: '14px',
    padding: '16px 20px',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px'
  })),
  ReviewTitle: styled('span')(() => ({
    fontSize: '13px',
    fontWeight: 600,
    color: '#112FBB'
  })),
  ReviewLine: styled('div')(() => ({
    display: 'flex',
    justifyContent: 'space-between',
    gap: '12px',
    fontSize: '13.5px',
    color: '#4D4D4D'
  })),
  ReviewTrade: styled('span')(() => ({
    fontWeight: 500,
    color: '#1A1A1A'
  })),
  ReviewDays: styled('span')(() => ({
    color: '#112FBB',
    fontWeight: 500,
    whiteSpace: 'nowrap'
  }))
};
